import Navbar from "../components/Navbar";
import Chapter1thongtin from "./Chapter1thongtin";
function Chapter1(){
    return(
        <>
        <Navbar/>
        <Chapter1thongtin/>
        </>
    )
}
export default Chapter1;